import React from 'react';
import {
  createFrontendPlugin,
  PageBlueprint,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';

const orionPage = PageBlueprint.make({
  params: {
    path: '/orion',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/OrionDocsPage').then(m => <m.OrionDocsPage />),
  },
});

const plugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'orion',
  extensions: [orionPage],
  routes: {
    root: rootRouteRef,
  },
});
export default plugin;
